import React, { useEffect, useState, useRef } from "react";
import { createPortal } from "react-dom";
import styles from "./MobileSlider.module.scss";
import { XClose } from "@untitled-ui/icons-react";
interface MobileSliderProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string | React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  contentClassName?: string;
  hasGameNames?: boolean;
  hasMarginBottom?: boolean;
  isFullScreen?: boolean;
  headerClassName?: string;
}
const MobileSlider: React.FC<MobileSliderProps> = ({
  isOpen,
  onClose,
  title,
  children,
  className = "",
  style,
  contentClassName = "",
  hasGameNames = false,
  hasMarginBottom = false,
  isFullScreen = false,
  headerClassName = "",
}) => {
  const [rootElement, setRootElement] = useState<HTMLDivElement | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [content, setContent] = useState<React.ReactNode>(null);
  const sliderRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const rootDiv = document.createElement("div");
    // Prevent Google Translate from mutating this portal container
    rootDiv.classList.add("notranslate");
    rootDiv.setAttribute("translate", "no");
    document.body.appendChild(rootDiv);
    setRootElement(rootDiv);
    return () => {
      if (rootDiv && rootDiv.parentNode === document.body) {
        document.body.removeChild(rootDiv);
      }
    };
  }, []);

  useEffect(() => {
    if (isOpen && !isClosing) {
      setContent(children);
    }
  }, [children, isOpen, isClosing]);

  useEffect(() => {
    if (isOpen) {
      document.documentElement.style.overflowY = "hidden";
      setIsVisible(true);
      setIsClosing(false);
      setContent(children);
      requestAnimationFrame(() => {
        setTimeout(() => {
          setIsTransitioning(true);
        }, 50);
      });
    } else if (isVisible) {
      setIsClosing(true);
      setIsTransitioning(false);
    }
    return () => {
      document.documentElement.style.overflowY = "scroll";
    };
  }, [isOpen, children]);
  const handleTransitionEnd = () => {
    if (isClosing) {
      setIsVisible(false);
      setIsClosing(false);
      setContent(null);
    }
  };
  const handleClose = () => {
    setIsClosing(true);
    setIsTransitioning(false);
    onClose();
  };
  if (!rootElement) {
    return null;
  }
  return createPortal(
    <>
      {isVisible && (
        <div
          // className={`${styles.popupContainer} ${import.meta.env.VITE_WIDGET_TOP_NAVBAR_ENABLED === "true" ? "" : styles.overNav}`}
          className={`${styles.popupContainer} ${hasMarginBottom === true ? styles.overNav : ""}`}
        >
          <div
            className={`${styles.overlay} ${isTransitioning ? styles.visible : ""}`}
            onClick={handleClose}
          />
          <div
            ref={sliderRef}
            className={`${styles.mobileSlider} ${isFullScreen ? styles.fullScreenSlider : ""} ${className} ${isTransitioning ? styles.open : ""}`}
            style={style}
            onTransitionEnd={handleTransitionEnd}
          >
            <div
              className={`${hasGameNames ? styles.gameNamesHeader : styles.header} ${headerClassName}`}
            >
              {typeof title === "string" ? <p className={styles.headerP}>{title}</p> : title}

              <XClose className={styles.closeIcon} onClick={handleClose} />
            </div>
            <div
              className={`${styles.content} ${isFullScreen ? styles.fullScreenContent : ""} ${contentClassName}`}
            >
              {content}
            </div>
          </div>
        </div>
      )}
    </>,
    rootElement
  );
};
export default MobileSlider;
